import { useDashboardScreenshotStore } from "stores/dashboardScreenshot/useDashboardScreenshotStore";

import { WidgetComponentType } from "models/screenshot";

import { useScreenshotContext } from "components/screenshot/hooks";
import { ControlDef } from "components/screenshot/models/controlDefinition";
import {
  ABBREVIATIONS_TOGGLE,
  CHART_FONT_SIZE_PRESETS,
  LEGEND_TOGGLE,
  MPC_AXIS_FONT_WEIGHT,
  MPC_TITLE_TEXT,
  fontFamilyControl
} from "components/screenshot/models/sharedControlDefs";
import { buildControls } from "components/screenshot/utils/buildScreenshotControls";
import { CHART_WIDGET_TYPES } from "components/shared/charts/hooks/chartWidgetTypes";

/** MPC-specific control definitions — declarative, visibility-tagged. */
const MPC_CONTROLS: readonly ControlDef[] = [
  LEGEND_TOGGLE,
  ABBREVIATIONS_TOGGLE,
  ...CHART_FONT_SIZE_PRESETS,
  MPC_TITLE_TEXT,
  MPC_AXIS_FONT_WEIGHT,
  fontFamilyControl()
];

function useMPCScreenshotSettingsControls() {
  const { widget } = useScreenshotContext();
  const dashboardWidgets = useDashboardScreenshotStore((s) => s.activeWidgets);
  const dashboardHasMPC = dashboardWidgets.some((w) => w.type === "multiphase-chart");
  const dashboardHasChart = dashboardWidgets.some((w) => CHART_WIDGET_TYPES.has(w.type));

  const isMPC = widget?.widgetComponentType === WidgetComponentType.Mpc;
  const isDashboardWithMPC =
    widget?.widgetComponentType === WidgetComponentType.Dashboard && dashboardHasMPC;

  if (!isMPC && !isDashboardWithMPC) return [];

  // When the dashboard also has regular charts, the chart hook already provides
  // the legend toggle — skip it here to avoid a duplicate control.
  const defs =
    isDashboardWithMPC && dashboardHasChart
      ? MPC_CONTROLS.filter((d) => d.name !== "legendVisible")
      : MPC_CONTROLS;

  return buildControls(defs, { isDashboard: isDashboardWithMPC });
}

export default useMPCScreenshotSettingsControls;
